import { VendorPo } from "components/POConfiguration/interfaces";
import { getString } from "common/ui-string-labels/ui-strings-utils";
import { API_BASE_URL } from "../configuration/config";
import { BaseService } from "./base-service";

export interface GetPOsParams {
    status?: boolean;
    vendor?: string;
    basePo?: string;
    limit?: number;
    nextToken?: string;
}

export interface CreatePOParams {
    vendor: string;
    basePo: string;
    budgetLimit: number;
}

interface CursorResponse {
    data: VendorPo[];
    nextToken: string | null;
}

export class POConfigurationService extends BaseService {
    public static instance = new POConfigurationService(API_BASE_URL);

    private readonly poPath = "/reseller/purchaseorders";

    public async getPOs(params: GetPOsParams): Promise<CursorResponse> {
        const queryParams = new URLSearchParams();
        if (params.status !== undefined) queryParams.set("status", String(params.status));
        if (params.vendor) queryParams.set("vendor", params.vendor);
        if (params.basePo) queryParams.set("basePo", params.basePo);
        if (params.limit !== undefined) queryParams.set("limit", String(params.limit));
        if (params.nextToken) queryParams.set("nextToken", params.nextToken);

        const response = await this.fetch(`${this.poPath}?${queryParams.toString()}`);

        if (!response.ok) {
            throw new Error(getString("poConfiguration.flashbar.error") || "Failed to fetch purchase orders");
        }

        return response.json();
    }

    public async createPO(data: CreatePOParams): Promise<VendorPo> {
        const response = await this.fetch(this.poPath, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.message || "Failed to create purchase order");
        }

        const result = await response.json();
        return result.po;
    }
}
